import React from 'react'
import sanitize from 'sanitize-html'

import styles from './CategorySelectionInfo.module.scss'

export interface ICategorySelectionInfoProps {
  guidelines: string
  description: string
  justification: string
  mode: 'multiple' | 'single'
}

export const CategorySelectionInfo = ({
  guidelines,
  description,
  justification,
  mode,
}: ICategorySelectionInfoProps) => {
  return (
    <div
      className={styles.container}
      onMouseDown={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
    >
      <div className={styles.title}>
        {mode === 'single' ? 'Single' : 'Multiple'} selection allowed
      </div>

      <div className={styles.title}>Guidelines</div>
      <div className={styles.paragraph}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitize(guidelines || 'No guidelines'),
          }}
        />
      </div>

      <div className={styles.title}>Description</div>
      <div className={styles.paragraph}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitize(description || 'No description'),
          }}
        />
      </div>

      <div className={styles.title}>Justification</div>
      <div className={styles.paragraph}>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitize(justification || 'No justification'),
          }}
        />
      </div>
    </div>
  )
}
